import React from 'react';

import styled from '@emotion/styled';

import CompanyLogo from '../../../components/CompanyLogo/CompanyLogo';
import LogoutIcon from '../../../components/Icons/LogoutIcon';
import { NavBoxItem } from '../../../components/Link/Link';
import { navConfig } from './navConfig';
import useOnLogout from '../../../hooks/auth/useHealthLogout';
import HelpIcon from '../../../components/Icons/HelpIcon';

const HealthNav = () => {
  const { logoutHealth } = useOnLogout();

  const handleHelpClick = () => {
    window.open('https://locumspace.co/contact-us', '_blank');
  };

  return (
    <Container>
      {/* <LogoContainer */}
      <CompanyLogo />
      <NavBtnSection>
        {navConfig.map((nav) => (
          <NavBoxItem path={nav.path} key={nav.title} icon={nav.icon}>
            {nav.title}
          </NavBoxItem>
        ))}
      </NavBtnSection>
        <Bottom>
          <HelpBox onClick={handleHelpClick}>
            <HelpIcon />
            Feedback
          </HelpBox>
          <LogoutBox onClick={() => logoutHealth()}>
            <LogoutIcon /> Logout
          </LogoutBox>
        </Bottom>
    </Container>
  );
};

export default HealthNav;

const Container = styled.nav`
  padding: 52px 32px 72px;
  display: flex;
  background-color: white;

  flex-direction: column;
  gap: 3.8rem;
  height: 100vh;
  position: sticky;
  top: 0;
  overflow: auto;

  /* Hide scrollbar but keep scrolling */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  & > a > div {
    margin-left: 1rem;
  }

  & > div {
    margin-left: 24px;
  }

  @media (max-width: 1024px) {
    padding: 1rem;
  }

  @media (max-width: 884px) {
    display: none;
  }
`;

const NavBtnSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const Bottom = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const LogoutBox = styled.div`
  color: ${({ theme }) => theme.palette.greyGrey2};
  font-size: 1rem;
  font-weight: 400;
  display: flex;
  gap: 1.25rem;
  cursor: pointer;
  align-items: center;

  @media (max-width: 1024px) {
    padding: 0.5rem 0.5rem;
    font-size: 0.8rem;
  }

  @media (max-width: 884px) {
    padding: 0;
    font-size: 1rem;
  }

  &:hover {
    color: ${({ theme }) => theme.palette.greyGrey1};
  }
`;

const HelpBox = styled.div`
  color: ${({ theme }) => theme.palette.greyGrey2};
  font-size: 1rem;
  font-weight: 400;
  display: flex;
  gap: 1.25rem;
  cursor: pointer;
  align-items: center;

  @media (max-width: 1024px) {
    padding: 0.5rem 0.5rem;
    font-size: 0.8rem;
  }

  @media (max-width: 884px) {
    padding: 0;
    font-size: 1rem;
  }

  &:hover {
    color: ${({ theme }) => theme.palette.greyGrey1};
  }
`;
